import React from "react";
import "./Projects.css";
import "../../assets/styles/swiper-bundle.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import Project1 from "../../assets/images/Project1Prev.png";
import Project2 from "../../assets/images/Project2.png";
import Project4 from "../../assets/images/Project4.png";
import CryptoProject from "../../assets/images/CryptoProject.png";
import { BiRightArrowAlt } from "react-icons/bi";

const Projects = () => {
  const options = {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 50,
      },
    },
    navigation: true,
    modules: [Autoplay, Navigation, Pagination],
    className: "mySwiper",
  };

  return (
    <section className="project__section" id="projects">
      <h2 className="section__title">Projects</h2>
      <span className="section__subtitle">Work Samples</span>
      <div className="projects__container container">
        <Swiper {...options}>
          <div className="wrapper">
            <SwiperSlide>
              {/* Project 1 */}
              <div className="projects__content grid">
                <img src={Project1} alt="" className="project__image" />
                <div className="project__data">
                  <h3 className="project__title">
                    GROCERY SHOP
                    <br /> MERN Stack Based
                  </h3>
                  <p className="project__description">
                    Grocery shop is an online grocery selling platform built
                    using MERN technology <br />
                  </p>
                  <a
                    href="https://grocery-shop-ten.vercel.app/"
                    target="_blank"
                    className="button button--flex button--small button__project"
                  >
                    View Live
                    <BiRightArrowAlt />
                  </a>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              {/* Project 3 */}
              <div className="projects__content grid">
                <img src={CryptoProject} alt="" className="project__image" />
                <div className="project__data">
                  <h3 className="project__title">
                    Cryptoverse
                    <br />
                    React Based
                  </h3>
                  <p className="project__description">
                    Cryptoverse is a real-time cryptocurrency data-fetching
                    application built using React. <br />
                  </p>
                  <a
                    href="https://cryptoapp-pradipkhamkar.vercel.app/"
                    target="_blank"
                    className="button button--flex button--small button__project"
                  >
                    View Live
                    <BiRightArrowAlt />
                  </a>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              {/* Project 3 */}
              <div className="projects__content grid">
                <img src={Project2} alt="" className="project__image" />
                <div className="project__data">
                  <h3 className="project__title">
                    E-Commerce
                    <br />
                    MERN Stack Based
                  </h3>
                  <p className="project__description">
                    E-Commerce is an online shopping platform built using MERN
                    technology. <br />
                  </p>
                  <a
                    href="https://github.com/PradipKhamkar/Mern-Ecommerce-Project"
                    target="_blank"
                    className="button button--flex button--small button__project"
                  >
                    View Code
                    <BiRightArrowAlt />
                  </a>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              {/* Project 4 */}
              <div className="projects__content grid">
                <img src={Project4} alt="" className="project__image" />
                <div className="project__data">
                  <h3 className="project__title">
                    G-Shop
                    <br />
                    Django Based <br />
                  </h3>
                  <p className="project__description">
                    G-Shop is an online shopping platform built using Django
                    Framework
                  </p>
                  <a
                    href="https://khamkar123.pythonanywhere.com/Home/"
                    target="_blank"
                    className="button button--flex button--small button__project"
                  >
                    View Live
                    <BiRightArrowAlt />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          </div>
        </Swiper>
      </div>
    </section>
  );
};

export default Projects;
